export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6789.62a84671.jpg";